import { render, staticRenderFns } from "./ButtonClassic.vue?vue&type=template&id=36fb62a6&"
import script from "./ButtonClassic.vue?vue&type=script&lang=js&"
export * from "./ButtonClassic.vue?vue&type=script&lang=js&"
import style0 from "./ButtonClassic.vue?vue&type=style&index=0&id=36fb62a6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports